import loaderAnimation from './data/loaderAnimation.json';
import { AnimationContainer } from '../../common/AnimationContainer';

export const Loader = () => {
  return <AnimationContainer json={loaderAnimation} />;
};
